import { VirtualTournament } from '@sportOfferFederation/competitions/types';
import { findVirtualTournamentByTournamentId } from '@sportOfferFederation/competitions/utilities/virtualTournamentsUtilities';

import { CompetitionsState } from './types';
import { union as _union } from 'lodash';
import { AvailableCompetitionTabs } from '../ui/types';

export function getTournamentToVirtualTournamentMapping(
    virtualTournaments: CompetitionsState['virtualTournaments'],
): Record<number | string, VirtualTournament> {
    const tournamentToVirtualTournament: Record<number | string, VirtualTournament> = {};
    virtualTournaments.forEach((virtualTournament) => {
        virtualTournament.childrenIds.forEach((tournamentId) => {
            tournamentToVirtualTournament[tournamentId] = virtualTournament;
        });
    });
    return tournamentToVirtualTournament;
}

export function getCurrentVirtualTournament(
    virtualTournaments: CompetitionsState['virtualTournaments'],
    rootGetters: any,
): VirtualTournament | undefined {
    if (rootGetters['ui/competitions/isOnCompetitionPage']) {
        const selectedItem = rootGetters['ui/sportOffer/sports/selectedItem'];
        return findVirtualTournamentByTournamentId(virtualTournaments, selectedItem.id);
    } else {
        return undefined;
    }
}

export function mergeIntoVirtualTournaments(
    currentVirtualTournaments: VirtualTournament[],
    newVirtualTournaments: VirtualTournament[],
    mergeFunction: (
        oldVirtualTournament: VirtualTournament,
        newVirtualTournament: VirtualTournament) => VirtualTournament,
): VirtualTournament[] {
    const mergedVirtualTournaments: VirtualTournament[] = [...currentVirtualTournaments];
    newVirtualTournaments.forEach((newVirtualTournament) => {
        const virtualTournamentToEdit = currentVirtualTournaments
            .find((virtualTournament) => virtualTournament.competitionId === newVirtualTournament.competitionId);
        if (virtualTournamentToEdit) {
            mergedVirtualTournaments.push(mergeFunction(virtualTournamentToEdit, newVirtualTournament));
        } else {
            mergedVirtualTournaments.push({ ...newVirtualTournament });
        }
    });
    return mergedVirtualTournaments;
}

export function virtualTournamentMergeFunction(
    oldTournament: VirtualTournament,
    newTournament: VirtualTournament,
): VirtualTournament {
    return {
        ...oldTournament,
        childrenIds: _union(oldTournament.childrenIds, newTournament.childrenIds),
        isHot: newTournament.isHot,
        sportTag: newTournament.sportTag,
        locations: newTournament.locations,
        colors: newTournament.colors,
    };
}

type HotTournamentLinkParseResult = {
    competitionId: number;
    competitionTab: Extract<AvailableCompetitionTabs, typeof AvailableCompetitionTabs.Outrights | typeof AvailableCompetitionTabs.Matches>;
    marketGroupId?: number;
};

export function parseHotTournamentLink(link: string): HotTournamentLinkParseResult {
    const url = new URL(link);

    const competitionId = Number(url.searchParams.get('competition_id'));
    const competitionTab = url.searchParams.get('tournament_tab') === 'outrights' ? AvailableCompetitionTabs.Outrights : AvailableCompetitionTabs.Matches;
    const marketGroupId = url.searchParams.has('market_group_id') ? Number(url.searchParams.get('market_group_id')) : undefined;

    return {
        competitionId,
        competitionTab,
        marketGroupId,
    };
}
